var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adm-report-status",style:({ background: _vm.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }